import React, { useMemo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import { Input, Select } from '~/components/Form';
import { t } from '~/helpers';
import { storeData, updateData } from '~/store/modules/tipoAreia/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();
  const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector((state) => state.tipoAreia);
  const [silo, setSilo] = useState('N');

  const initials = create ? data : { ...find, ...data };

  const status = useMemo(
    () => [
      { value: 'S', label: t('s.geral.opcoes.sim') },
      { value: 'N', label: t('s.geral.opcoes.nao') },
    ],
    []
  );

  async function handleSubmit(param) {
    try {
      const schema = Yup.object().shape({
        descricaotipoareia: Yup.string()
          .trim()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(0, t('s.geral.validacao.campoobrigatorio'))
          .max(50, t('s.geral.validacao.tamanhomaximo').replace('%s', 50)),
        pesounitariokgtipoareia:
          silo === 'S'
            ? Yup.number().nullable()
            : Yup.number()
                .typeError(t('s.geral.validacao.campoobrigatorio'))
                .required(t('s.geral.validacao.campoobrigatorio'))
                .moreThan(0, t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(param, { abortEarly: false });

      const objSend = {
        ...initials,
        ...param,
        idcliente: client,
        pesounitariokgtipoareia:
          silo === 'S' ? 1 : Number(param.pesounitariokgtipoareia),
      };

      if (create) {
        dispatch(storeData(objSend, params));
      } else {
        dispatch(updateData(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
    }
  }

  useEffect(() => {
    if (!loading && reference.current) {
      reference.current.setData(initials);
    }
  }, [loading, initials, reference]);

  return loading ? (
    <div style={{ height: '14rem', width: '50rem' }}>
      <Spinner loading />
    </div>
  ) : (
    <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
      <Input
        name="descricaotipoareia"
        label={t('s.cadastro.modeloveiculo.descricao')}
        variant="outlined"
        fullWidth
        size="small"
        InputLabelProps={{ shrink: true }}
      />
      <Select
        name="silotipoareia"
        label={t('s.cadastro.pitstop.silotipoareia')}
        options={status}
        disabled={!create}
        getValue={(value) => {
          if (value) {
            setSilo(value);
            reference.current.setFieldValue('silotipoareia', value);
          }
        }}
      />
      {silo === 'N' && (
        <Input
          name="pesounitariokgtipoareia"
          label={t('s.cadastro.pitstop.sacosatendimentoareia')}
          variant="outlined"
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
        />
      )}
    </Form>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
